var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartsoft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53668 8.41414C6.8417 8.12233 6.30888 7.53872 6.30888 6.74355C6.30888 5.94837 7.1583 5 8.15444 5C9.15058 5 8.69498 5 8.84942 5.1459C10.3089 5.80247 14.7722 7.90348 14.7722 7.90348C15.5444 8.34119 16 9.06341 16 9.93883V12.8423C16 13.4989 15.6139 14.0752 15.0734 14.367L8.54054 17.7811C7.92278 18.073 7.23552 18.073 6.61776 17.7811L0.23166 14.0825C0.0772201 14.0095 0 13.8636 0 13.6448C0 13.4259 5.75334e-09 13.4259 0.0772201 13.353C0.540541 12.6964 1.45946 12.266 2.3861 12.3389C2.7722 12.3389 3.08108 12.4848 3.38224 12.6308C4 12.9955 5.76834 14.2284 7.6139 14.2284C9.45946 14.2284 10.4556 13.2873 10.4556 13.2873C11.0734 12.8496 11.529 11.9085 11.529 11.1061C11.529 10.3036 11.0656 9.72727 10.3012 9.43547L7.52896 8.34848V8.42144L7.53668 8.41414Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71094 17.7722C8.08594 18.0759 7.39062 18.0759 6.76562 17.7722L0.234375 13.9907C0.078125 13.9147 0 13.7628 0 13.535C0 13.3072 5.82077e-09 13.3072 0.078125 13.2313C0.546875 12.5479 1.47656 12.0999 2.41406 12.1758C2.80469 12.1758 3.11719 12.3277 3.42188 12.4796C4.04688 12.8592 5.83594 14.1425 7.70313 14.1425C9.57031 14.1425 10.5781 13.163 10.5781 13.163C11.2031 12.7074 11.6641 11.7278 11.6641 10.8925C11.6641 10.0572 11.1953 9.45736 10.4219 9.15362L7.61719 8.0222C6.91406 7.71846 6.375 7.11098 6.375 6.28329C6.375 5.45561 6.60938 5.30374 6.92188 5C6.60938 5.30374 6.45312 5.68341 6.45312 6.05549C6.45312 6.7389 6.92188 7.26285 7.46094 7.49065L11.4297 8.92582C12.9062 9.45736 14 10.8925 14 12.5555C14 14.2185 13.1406 15.2815 11.9766 15.9574L8.71094 17.6963V17.7722Z",
    fill: "url(#paint0_linear_84_9153)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7752 3.68195C14.9251 3.7574 15 3.9083 15 4.13465V4.361C14.7003 5.1155 14.0335 5.4852 14.0335 5.4852C13.5839 5.71155 12.992 5.787 12.4675 5.56065C12.3177 5.56065 12.0929 5.40975 12.018 5.3343C11.4935 4.95705 9.77772 3.7574 7.98701 3.7574C6.34615 3.7574 5.2972 4.6628 5.2972 4.6628C4.6978 5.1155 4.33067 5.9379 4.33067 6.6924V6.8433C4.33067 7.59779 4.78022 8.2693 5.44705 8.49565L8.13686 9.61985C8.81119 9.92165 9.32817 10.5252 9.32817 11.2722C9.32817 12.0192 8.504 13 7.53746 13C6.57093 13 7.08791 13 6.86314 12.8491C5.44705 12.2455 1.19131 10.1405 1.19131 10.1405C0.442058 9.68775 0 8.9408 0 8.1863V5.40975C0 4.7307 0.374625 4.13465 0.899101 3.7574L7.16284 0.226349C7.76224 -0.0754498 8.42907 -0.0754498 9.02847 0.226349L14.7752 3.68195Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7752 3.68195C14.9251 3.7574 15 3.9083 15 4.13465V4.361C14.7003 5.1155 14.0335 5.4852 14.0335 5.4852C13.5839 5.71155 12.992 5.787 12.4675 5.56065C12.3177 5.56065 12.0929 5.40975 12.018 5.3343C11.4935 4.95705 9.77772 3.7574 7.98701 3.7574C6.34615 3.7574 5.2972 4.6628 5.2972 4.6628C4.6978 5.1155 4.33067 5.9379 4.33067 6.6924V6.8433C4.33067 7.59779 4.78022 8.2693 5.44705 8.49565L8.13686 9.61985C8.81119 9.92165 9.32817 10.5252 9.32817 11.2722C9.32817 12.0192 8.504 13 7.53746 13C6.57093 13 7.08791 13 6.86314 12.8491C5.44705 12.2455 1.19131 10.1405 1.19131 10.1405C0.442058 9.68775 0 8.9408 0 8.1863V5.40975C0 4.7307 0.374625 4.13465 0.899101 3.7574L7.16284 0.226349C7.76224 -0.0754498 8.42907 -0.0754498 9.02847 0.226349L14.7752 3.68195Z",
    fill: "url(#paint1_linear_84_9153)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9187 4.30502C14.549 4.92278 13.9649 5.23166 13.2994 5.23166C12.634 5.23166 12.4861 5.07722 12.1238 4.76834C10.8743 3.7722 9.25508 3 7.56192 3C5.05545 3 3 5.46332 3 7.99614C3 10.529 3.88725 11.2239 5.06285 11.9961C5.80222 12.3822 6.46026 12.6911 6.90388 12.8456C7.12569 12.9228 7.3475 13 7.56932 13C8.52311 13 9.33641 12.2278 9.33641 11.2317C9.33641 10.2355 9.04067 10.0811 8.52311 9.7722H8.44917C8.37523 9.7722 8.30129 9.69498 8.22736 9.61776L7.56192 9.30888L5.57301 8.45946C4.90758 8.15058 4.47135 7.53282 4.47135 6.76834V6.6139C4.47135 5.8417 4.91497 5 5.42514 4.53668C5.42514 4.53668 6.45287 3.61004 8.07948 3.61004C8.37523 3.61004 8.59704 3.61004 8.89279 3.68726C10.3641 3.99614 11.6137 4.91506 12.0573 5.22394C12.2052 5.30116 12.3531 5.37838 12.5009 5.4556H12.7967C13.2403 5.4556 13.6839 5.4556 14.0462 5.30116C14.0462 5.30116 14.7116 4.91506 15 4.15058L14.9261 4.30502H14.9187Z",
    fill: "#535353"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9187 4.30502C14.549 4.92278 13.9649 5.23166 13.2994 5.23166C12.634 5.23166 12.4861 5.07722 12.1238 4.76834C10.8743 3.7722 9.25508 3 7.56192 3C5.05545 3 3 5.46332 3 7.99614C3 10.529 3.88725 11.2239 5.06285 11.9961C5.80222 12.3822 6.46026 12.6911 6.90388 12.8456C7.12569 12.9228 7.3475 13 7.56932 13C8.52311 13 9.33641 12.2278 9.33641 11.2317C9.33641 10.2355 9.04067 10.0811 8.52311 9.7722H8.44917C8.37523 9.7722 8.30129 9.69498 8.22736 9.61776L7.56192 9.30888L5.57301 8.45946C4.90758 8.15058 4.47135 7.53282 4.47135 6.76834V6.6139C4.47135 5.8417 4.91497 5 5.42514 4.53668C5.42514 4.53668 6.45287 3.61004 8.07948 3.61004C8.37523 3.61004 8.59704 3.61004 8.89279 3.68726C10.3641 3.99614 11.6137 4.91506 12.0573 5.22394C12.2052 5.30116 12.3531 5.37838 12.5009 5.4556H12.7967C13.2403 5.4556 13.6839 5.4556 14.0462 5.30116C14.0462 5.30116 14.7116 4.91506 15 4.15058L14.9261 4.30502H14.9187Z",
    fill: "url(#paint2_linear_84_9153)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_84_9153",
    x1: 2.39844,
    y1: 20.559,
    x2: 8.44379,
    y2: 10.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#181818",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#262626",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5B5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_84_9153",
    x1: 7.5,
    y1: -2.0296,
    x2: 7.5,
    y2: 14.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38F2CC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_84_9153",
    x1: 8.98891,
    y1: 20.6062,
    x2: 8.98891,
    y2: 7.22394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#616161",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#171717",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6E6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartsoft);
export default __webpack_public_path__ + "static/media/smartsoft.59669114fbf3b2404e2436619ba8ee6d.svg";
export { ForwardRef as ReactComponent };